import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/hierarchy.action'
import hierarchyList from 'api/hierarchy/List'

async function getList(
  page: number,
  searchText: string,
  sort: any[],
  perPage: number
) {
  return hierarchyList(page, searchText, sort, perPage)
}

function* hiearchyListEffectSaga(action: any) {
  try {
    const { page, searchText, sort, perPage } = action.payload

    const { data, total } = yield call(getList, page, searchText, sort, perPage)
    yield put(
      fromActions.Actions.hierarchyListSuccess(data, total, perPage, sort)
    )
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* hierarchyListWatcherSaga() {
  yield takeLatest(fromActions.HIERARCHY_LIST_GET, hiearchyListEffectSaga)
}
